import { render, staticRenderFns } from "./NutrientRequirements.vue?vue&type=template&id=55947d8a&scoped=true&lang=html&"
import script from "./NutrientRequirements.vue?vue&type=script&lang=js&"
export * from "./NutrientRequirements.vue?vue&type=script&lang=js&"
import style0 from "./NutrientRequirements.vue?vue&type=style&index=0&id=55947d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55947d8a",
  null
  
)

export default component.exports